
import AddressFormatter from './AddressFormatter';

const Address = (address, translator) => {
    return AddressFormatter(address, translator);
};
export default Address;
